module.exports = function (app) {
    require("pages/claims/claims")(app);
    app.controller('pages.claims', ["$state", "$scope","contentService", "sessionData",
            function ($state, $scope, contentService, sessionData) {
                // Sidebar
                $scope.$parent.sidebar = {
                    breadCrumb: {
                        primary: {
                            title: "Find Employees",
                            state: "employee.find"
                        },
                        secondary: {
                            title: "Agreement to View Claims"
                        }
                    }
                };
                $scope.feedback = {};
                $scope.hasAtLeastOneEntitlement = false;
              
                var paHasPermissions = function(sd) {
                    var es = sd.entitlements;
                    var hasAtLeastOneEntitlement = (
                            (es.employees.view == true) ||
                            (es.employees.edit == true)
                        ) ? true : false;
                    var hasViewClaimsPermission = ((sd.employerInfo.planAdministratorEntitlements.userLevelEntitlements['View Claims'])
                        && (sd.employerInfo.planAdministratorEntitlements.userLevelEntitlements['View Claims'] == true)) ? true : false;
                    $scope.hasAtLeastOneEntitlement = hasAtLeastOneEntitlement && hasViewClaimsPermission;
                    if (!$scope.hasAtLeastOneEntitlement) {
                        setTimeout(function() {
                            $scope.feedback.showFeedback('You do not have permissions to view this screen', 'notification');
                        }, 500);
                    }
                }
                paHasPermissions(sessionData);

                $scope.print=function(){
                    contentService.get("EPR_CLAIMS_AGREEMENT").then(function(response){
                        var win = window.open();
                        win.document.open();
                        win.document.write('<html><body>');
                        win.document.write('<h1>Agreement to View Claims</h1>');
                        win.document.write(response);
                        win.document.write('</body></html>');
                        win.document.close();
                        win.print();
                        win.close();
                    });
                };
                $scope.goToClaims=function(){
                    $state.go('claims.summary',{umi:$state.params.umi,groupNumber:$state.params.groupNumber});
                };  } ]
    );

    return [
        {
            state: "claims",
            url: "/claims",
            postPassword: true,
            params: { groupNumber: '', umi: '' },
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html']
                },
                "content@claims": {
                    templateUrl: "claims.employerTemplate.html/pages/claims/claims-agreement",
                    controller: "pages.claims"  // << THIS js file
                }
            }
        },
        {
            state: "claims.summary",
            url: "/summary?startDate&endDate",
            postPassword: true,
            views: {
                'body@': {
                    templateUrl: "claims/summary.employerTemplate.html/pages/claims/content-page-refine"                },
                "content@claims.summary": {
                    templateUrl: "claims/summary.employerTemplate.html/pages/claims/claims",
                    controller: "pages.claims.summary"
                }
            }
        }
    ];
};

